import RequestAuth from "../../components/fetch/auth";
import RequestSite from "../../components/fetch/site";

export const setUser = user => ({
  type: "SET_USER",
  user
});

export const logOut = () => ({
  type: "LOGOUT_USER"
});

export const goTo = page => ({
  type: "GO_TO",
  page
});

export const setLang = data => ({
  type: "SET_LANG",
  data
});

export const category = category => ({
  type: "TYPE_SHOW",
  category
});
export const myInvoice = ({ number, paid }) => ({
  type: "GET_INVOICE",
  paid,
  number
});

export const initializeMap = () => dispatch => {
  const token = localStorage.getItem("token");
  if (token) {
    const body = {
      query: `
      query {
        user(id:"me"){
        name
        email
        picture
        mobile
        role
        hasPassword
        }
      }
    `
    };
    RequestAuth({ auth: `Bearer ${token}`, body: JSON.stringify(body) })
      .then(({ user }) => {
        dispatch(setUser({ user, token }));
        const data = {
          query: `
          query{
            myInvoice{
              id
              status
              invoiceProducts{
                productId{
                  id
                  name
                }
              }
            }
          }
        `
        };
        RequestSite({ auth: token, body: JSON.stringify(data) })
          .then(response => {
            // console.log("response", response);
            if (response.myInvoice !== null) {
              const number = response.myInvoice.invoiceProducts.length;
              dispatch(myInvoice({ number, paid: true }));
            }
          })
          .catch(console.log);
      })
      .catch(console.log);
  }
};
